import clsx from 'clsx';
import React from 'react';
import IconCommon from '@/components/Common/DesignSystem/Icon/IconCommon';

import styles from './SwiperNavs.module.scss';

export const prevButton = (className?: string) => (): JSX.Element => (
  <span className={clsx(styles.prevButton, className)}>
    <IconCommon type="icon_arrowback_fill" className={styles.iconWrap} />
  </span>
);

export const nextButton = (className?: string) => (): JSX.Element => (
  <span className={clsx(styles.nextButton, className)}>
    <IconCommon type="icon_arrowforward_fill" className={styles.iconWrap} />
  </span>
);

export const renewalPrevButton = (className?: string) => (): JSX.Element => (
  <span className={clsx(styles.renewalPrevButton, className)}>
    <IconCommon type="icon_arrowback_fill" className={styles.iconWrap} />
  </span>
);

export const renewalNextButton = (className?: string) => (): JSX.Element => (
  <span className={clsx(styles.renewalNextButton, className)}>
    <IconCommon type="icon_arrowforward_fill" className={styles.iconWrap} />
  </span>
);
